<template>
    <section>
        <div :id="'bar_' + title" style="width: 100%; height: 700px;" />
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import * as echarts from 'echarts'
export default {

    props: [
        'years', 'title',
    ],

    data() {
        return {
            isLoading: false,
            option: {
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        dataView: {
                            show: true,
                            readOnly: true,
                            title: 'Datos',
                            lang: ["Datos", "Cerrar", "Actualizar"],
                            optionToContent: function (opt) {
                                var series = opt.series[0]
                                var years = opt.xAxis[0].data
                                var table = '<table class="echarts-dataview-table">'
                                const formatterCLP = new Intl.NumberFormat('es-CL', {
                                    style: 'currency',
                                    currency: 'CLP',
                                })
                                table += '<thead><tr><th>Nombre</th>'
                                years.forEach((year) => {
                                    table += '<th>'+ year + '</th>'
                                })
                                table += '</tr></thead>'
                                table += '<tbody>'
                                table += '<tr>'
                                    + '<td style="text-align: left; border: 1px solid #ccc; ">Total</td>'

                                series.data.forEach((value) => {
                                    var newValue = value == 0 ? formatterCLP.format(value) : '<b>' + formatterCLP.format(value) + '</b>'
                                    table += '<td style="text-align: center; border: 1px solid #ccc">' + newValue  + '</td>'
                                })

                                table += '</tr>'
                                table += '</tbody></table>'
                                return table;
                            },
                        },
                        saveAsImage: {
                            show: true,
                            pixelRatio: 3,
                            title: "Descargar",
                            name: 'indicator_by_year',
                        },
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    },
                    {
                        type: 'slider'
                    }
                ],
                grid: {
                    left: '0%',
                    right: '20%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: 'Total',
                        type: 'bar',
                        data: [],
                        itemStyle: {
                            color: '#00A499',
                        },
                        label:{
                            show: true,
                            formatter: (params) => {
                                const formatterCLP = new Intl.NumberFormat('es-CL', {
                                    style: 'currency',
                                    currency: 'CLP',
                                })
                                return formatterCLP.format(params.value)
                            }
                        }
                    }
                ]
            }
        }
    },

    async mounted() {
        this.$nextTick(() => {
            this.initECharts()
        })
    },

    methods: {
        async initECharts() {
            this.isLoading = true

            this.option.xAxis[0].data = []
            this.option.series[0].data = []

            this.option = await this.setOptions(this.years, this.option)

            // based on prepared DOM, initialize echarts instance
            this.dom = echarts.init(document.getElementById('bar_' + this.title))
            this.dom.setOption(this.option)
            new ResizeObserver(() => this.dom.resize()).observe(document.getElementById('bar_' + this.title))

            this.isLoading = false
        },

        setOptions(years, option) {
            
            return new Promise(function (resolve) {

                option.xAxis[0].data = years.years

                var i = 0

                option.series[0].data = years.series

                resolve(option)
            })

        },

    },

    watch: {
        years() {
            this.initECharts()
            deep: true
        },
    },
}
</script>